var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ExplorerProjectsNamespaces',_vm._b({},'ExplorerProjectsNamespaces',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }